// Englische Fassung von ../de/overview.ts.
import type { OverviewKatalog } from "../de/overview";

export const overview: OverviewKatalog = {
  gutenMorgen: "Good morning",
  hallo: "Hello",
  gutenAbend: "Good evening",
  bald: "(soon)",
  faelligDieseWoche: (n: number) =>
    `${n} ${n === 1 ? "task" : "tasks"} due this week`,
  zuletzt: "Recent",
  alleChats: "All chats",
  gerade: "just now",
  vorMinuten: (n: number) => `${n} min ago`,
  vorStunden: (n: number) => `${n} h ago`,
  vorTagen: (n: number) => `${n} d ago`,
};
